import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import { AuthProvider } from './provider/authentication'
import { WebsocketProvider } from './provider/websocket'
import { MediaSourceProvider } from './provider/mediaSource'
import { PlayerProvider } from './provider/playerSource'
import { ScreenShareProvider } from './provider/screenShare'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <React.StrictMode>
    <AuthProvider>
      <WebsocketProvider>
        <MediaSourceProvider>
          <PlayerProvider>
            <ScreenShareProvider>
              <App />
            </ScreenShareProvider>
          </PlayerProvider>
        </MediaSourceProvider>
      </WebsocketProvider>
    </AuthProvider>
  </React.StrictMode>
)
